import config from '../helper/config'

const domain_dev = "https://fintech-stg.bedigital.co.id/"
const domain_stg = "https://apiweb2.posfin.id/"
const domain_prod = "https://apiweb.posfin.id/"
let domain = domain_prod
if (config.env === 'development') {
    domain = domain_dev
} else if (config.env === 'staging') {
    domain = domain_stg
} else {
    domain = domain_prod
}

const base_url = domain + "api/v1/";
let whitelabel_36 = config.whitelabel.toString(36).toUpperCase()

const apis = {
    domain : domain,
    base_url : base_url,
    login : base_url + "master-agent/auth/login",
    logout : base_url + "master-agent/auth/logout",
    get_captha : base_url + "master-agent/auth/captcha/" + whitelabel_36 + "/image.png",
    refresh_captha : base_url + "master-agent/auth/captcha/" + whitelabel_36 + "/refresh",
    get_profile : base_url + "master-agent/profile/info",
    update_profile : base_url + "master-agent/profile/edit",
    update_account : base_url + "master-agent/update-account",
    upload_photo: base_url + "master-agent/profile/upload/photo",
    verify_identity : base_url + "master-agent/verify-identity",
    balance_main : base_url + "master-agent/balance/deposit",
    change_password : base_url + "master-agent/password/change",
    forgot_password : base_url + "master-agent/password/forgot",
    list_propinsi : domain + "api/helper/geoname/province/list",
    list_kota: domain + "api/helper/geoname/{provinsi_id}/city/list",
    list_district: domain + "api/helper/geoname/{provinsi_id}/{kota_id}/district/list",
    list_village: domain + "api/helper/geoname/{provinsi_id}/{kota_id}/{district_id}/village/list",
    list_history_fee : base_url + "master-agent/report/commission/list",
    list_history_bonus : base_url + "master-agent/report/bonus/list/",
    list_history_tx : base_url + "master-agent/trx/history/cashout",
    list_history_bal : base_url + "master-agent/trx/history/cashin",
    list_upline : base_url + "master-agent/org/upline/list",
    list_downline : base_url + "master-agent/org/downline/list",
    list_my_agent_all : base_url + "master-agent/org/my-agent/list/all",
    list_my_agent_active : base_url + "master-agent/org/my-agent/list/active",
    list_my_agent_registering : base_url + "master-agent/org/my-agent/list/registering",
    list_my_agent_suspended : base_url + "master-agent/org/my-agent/list/suspended",
    list_my_agent_unapproved : base_url + "master-agent/org/my-agent/list/unapproved",
    list_my_agent_deactivated : base_url + "master-agent/org/my-agent/list/deactivated",
    list_downline_agent : base_url + "master-agent/org/downline/detail/",
    list_master_by_level: base_url + "master-agent/list-by-level/{master_id}",
    change_status_agent : base_url + "master-agent/org/my-agent/detail/",
    change_status_agent_of_downline : base_url + "master-agent/org/downline/detail/{master_id}/agent/detail/{agent_id}/change-status",
    change_status_master : base_url + "master-agent/org/downline/detail/{master_id}/change-status",
    report_monthly: base_url + "master-agent/report/commission/monthly/",
    report_monthly_bonus: base_url + "master-agent/report/bonus/monthly/",
    list_services: base_url + "master-agent/setting/service/list",
    simulasi_komisi: base_url + "master-agent/simulation/product-commission/",
    simulasi_bonus: base_url + "master-agent/simulation/product-bonus/",
    simulasi_komisi_downline: base_url + "master-agent/org/downline/detail/{master_id}/simulation/product-commission/{product_id}",
    simulasi_bonus_downline: base_url + "master-agent/org/downline/detail/{master_id}/simulation/product-bonus/{product_id}",
    monthly_report_agent_downline_commision: base_url + "master-agent/org/downline/detail/",
    monthly_report_agent_downline_bonus: base_url + "master-agent/org/downline/detail/",
    monthly_report_agent_me_commision: base_url + "master-agent/org/my-agent/detail/",
    monthly_report_agent_me_bonus: base_url + "master-agent/org/my-agent/detail/",
    monthly_report_downline_commision: base_url + "master-agent/org/downline/detail/",
    monthly_report_downline_bonus: base_url + "master-agent/org/downline/detail/",
    get_settings: base_url + "master-agent/setting/detail",
    modify_settings: base_url + "master-agent/setting/change",
    search_agent_master_downline: base_url + "master-agent/org/downline/detail/",
    search_my_agent: base_url + "master-agent/org/my-agent/search/",
    agent_commision_realize: base_url + "master-agent/org/my-agent/detail/{agent_id}/report/commission/realize",
    agent_bonus_realize: base_url + "master-agent/org/my-agent/detail/{agent_id}/report/bonus/realize",
    agent_of_downline_commision_realize: base_url + "master-agent/org/downline/detail/{master_id}/agent/detail/{agent_id}/report/commission/realize",
    agent_of_downline_bonus_realize: base_url + "master-agent/org/downline/detail/{master_id}/agent/detail/{agent_id}/report/commission/realize",
    master_commision_realize: base_url + "master-agent/org/downline/detail/{master_id}/report/commission/realize",
    master_bonus_realize: base_url + "master-agent/org/downline/detail/{master_id}/report/bonus/realize",
    create_my_agent: base_url + "master-agent/org/my-agent/new",
    create_agent_of_downline: base_url + "master-agent/org/downline/detail/{master_id}/agent/new",
    create_downline: base_url + "master-agent/org/downline/new/{master_id}",
    sms_token_submit: base_url + "master-agent/auth/submit-token-sms",
    sms_token_resend: base_url + "master-agent/auth/resend-token-sms",
    transfer_balance_my_agent: base_url + "master-agent/org/my-agent/detail/{agent_id}/balance/transfer",
    transfer_balance_my_downline: base_url + "master-agent/org/downline/detail/{master_id}/balance/transfer",
    transfer_balance_agent_of_downline: base_url + "master-agent/org/downline/detail/{master_id}/agent/detail/{agent_id}/balance/transfer",
    download_agent_list: base_url + "master-agent/data/agent-list",
    request_batch_realisasi_bonus: base_url + "master-agent/org/report/agent/bonus/data-realize",
    request_batch_realisasi_komisi: base_url + "master-agent/org/report/agent/commission/data-realize",
    request_batch_p2p: base_url + "master-agent/org/report/agent/balance/data-transfer",
    request_batch_p2p_downline: base_url + "master-agent/org/report/downline/balance/data-transfer",
    submit_batch_realisasi_bonus: base_url + "master-agent/org/report/agent/bonus/batch-realize",
    submit_batch_realisasi_komisi: base_url + "master-agent/org/report/agent/commission/batch-realize",
    submit_batch_p2p: base_url + "master-agent/org/report/agent/balance/batch-transfer",
    submit_batch_p2p_downline: base_url + "master-agent/org/report/downline/balance/batch-transfer",
    list_device_agent : base_url + "master-agent/org/my-agent/detail/{agent_id}/device/list/{platform}",
    list_device_agent_of_downline : base_url + "master-agent/org/downline/detail/{master_id}/agent/detail/{agent_id}/device/list/{platform}",
    change_status_device_agent : base_url + "master-agent/org/my-agent/detail/{agent_id}/device/change-status",
    change_status_device_agent_of_downline : base_url + "master-agent/org/downline/detail/{master_id}/agent/detail/{agent_id}/device/change-status",
    add_device_agent : base_url + "master-agent/org/my-agent/detail/{agent_id}/device/new",
    add_device_agent_of_downline : base_url + "master-agent/org/downline/detail/{master_id}/agent/detail/{agent_id}/device/new",
    search_device_agent : base_url + "master-agent/org/my-agent/detail/{agent_id}/device/search/desktop",
    search_device_agent_of_downline : base_url + "master-agent/org/downline/detail/{master_id}/agent/detail/{agent_id}/device/search/{platform}",
    get_workstation: base_url + "master-agent/work-station/list",
    search_workstation: base_url + "master-agent/work-station/search",
    change_status_workstation: base_url + "master-agent/work-station/change-status",
    change_password_workstation: base_url + "master-agent/work-station/change-password",
    add_new_workstation: base_url + "master-agent/work-station/new",
    reserve_transfer_balance: base_url + "master-agent/trx/history-reverse-transfer",
    reserve_transfer_balance_info: base_url + "master-agent/trx/history-info-before-reverse-transfer",
    download_list_commision: base_url + "master-agent/report/commission/data-trx",
    download_list_bonus: base_url + "master-agent/report/bonus/data-trx",
    download_list_transaction: base_url + "master-agent/report/history/data-trx"
};

export default apis


// WEBPACK FOOTER //
// ./src/helper/api.js